<template>
  <div  :class="{ 'loading-opacity': preloader }" class="content-wrapper">
    <app-overlay-loader v-if="preloader" />
    <div class="row">
      <p v-if="preloader && requestServe" class="text-center">
        Este proceso puede llevar un tiempo. <br />
        <span class="font-weight-bold">Procesando: {{ loading }}% </span> 
      </p>
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          page-title="Emisión de Resolución"
          directory="Emisión de Resolución"
          :icon="'trello'"
        />
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            @click="returnPage()"
          >
            {{ $t("back") }}
          </button>
          <button
            type="button"
            class="btn btn-success btn-with-shadow ml-3"
            @click="openDeleteModal"
          >
            Procesar
          </button>
        </div>
      </div>

      <div class="col-md-12">
        <app-tab
          :tabs="tabsHorizontal"
          type="horizontal"
          v-if="showMaintenancePlan"
        />
        <app-tab
          :tabs="tabsHorizontalMaintenace"
          type="horizontal"
          v-if="!showMaintenancePlan"
        />
      </div>
    </div>

    <app-confirmation-modal
      v-if="deleteConfirmationModalActive"
      :preloader="deleteLoader"
      modal-id="modal-confirm-id"
      @confirmed="confirmed"
      @cancelled="cancelled"
      title="Confirmación"
      message="¿Desea procesar este registro?"
      firstButtonName="Aceptar"
      secondButtonName="Cancelar"
      modalClass="success"
      icon="cpu"
    />
  </div>
</template>

<script>
import * as actions from "../../../apiUrl";
import { axiosPatch } from "@/app/helpers/AxiosHelper";
export default {
  props: {
    accAppId: String,
  },
  data() {
    return {
      app_type: "",
      icon: "settings",
      accApp: null,
      loading: 0,
      requestServe: false,
      preloader: false,
      tabsHorizontal: [
        {
          icon: "award",
          name: "Emisión de Resolución",
          component: "issuance-resolution-612-annexes",
          permission: "",
        },
      {
          icon: "send",
          name: "Alcances Registrados",
          component: "scopes-evaluator-indexx",
          permission: "",
        },
        {
          icon: "briefcase",
          name: "Plan de Mantenimiento",
          component: "closure-findings-decision-plan",
          permission: "",
        },
        {
          icon: "briefcase",
          name: "Devolver proceso",
          component: "return-process-index",
          permission: "",
        },
      ],

      tabsHorizontalMaintenace: [
        {
          icon: "briefcase",
          name: "Emisión de Resolución",
          component: "issuance-resolution-612-annexes",
          permission: "",
        },
        {
          icon: "send",
          name: "Alcances Registrados",
          component: "scopes-evaluator-indexx",
          permission: "",
        },
        {
          icon: "briefcase",
          name: "Devolver proceso",
          component: "return-process-index",
          permission: "",
        },
      ],
      showMaintenancePlan: false,
      deleteConfirmationModalActive: false,
      deleteLoader: false,
    };
  },
  created() {
    this.$store.state.accreditation.id = this.accAppId;
    this.accApp = this.$store.state.accreditation;
    this.data();
     this.getActivity();
  },
  methods: {
    returnPage() {
      window.location.href = `${actions.EXECUTIVE_DIRECTOR}/issuanceResolution?tab=Emisión%20de%20Resolución`;
    },
    data() {
      // this.$store.dispatch("getEvalTest");
    },
    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },
    confirmed() {
      this.deleteLoader = true;
      this.preloader = true;
      this.requestServe = true;
      let url = `${actions.EXECUTIVE_DIRECTOR}/issuanceResolution/612/process?accAppId=${this.accAppId}`;
      let options = {
        method: 'PATCH',
        url: url,
        data: null
      }

      let attempts = 0;
      async function request(options){
        let info = null;
        try{
            const response = await axios.request(options);
            info = await response.data;
            if(!info.status){
              throw Error(info.message);
            }
        }catch(e){
          throw Error(e.message);
        }
      }

      request(options)
      .then(() => {
        this.$toastr.s("Registro procesado con exito");
        this.returnPage();
      })
      .catch(e => {
        this.$toastr.e(e.message);
        this.cancelled();
      })
      .finally(() => {
        this.cancelled();
        this.deleteLoader = false;
        this.preloader = false;
      });
      
    },

    getActivity() {
      axios
        .get(
          `/evaluator/documentaryEvaluation/activity/${this.$store.state.accreditation.id}?accApp=1`
        )
        .then((res) => {
          if (res.data.accreditation_type.name == "Acreditación Inicial") {
            this.showMaintenancePlan = true;
          }
          this.$store.state.accreditation.id = res.data.id;
          this.$store.state.accreditation.app = res.data;
        });
    },
    cancelled() {
      this.deleteConfirmationModalActive = false;
    },
  },
};
</script>
